<template>
<div class="chapter">
<div class="inner_page">
<p class="ct1"><a id="page_xiii"></a><a href="#/contenttoc#tc" id="cc">PROLOGUE</a></p>
<p class="tx1">Before David ‘s traumatic brain injury, we lived a normal life. We both grew up in Erie, Pennsylvania. I went to a girls’ high school; he went to the boys’ school. I lived on the west side of town, while he lived on the east side. On that starry night in 1965 when I met him, I knew he would be my life partner. He didn’t know it yet. He knew by 1969, when we said our vows. I was twenty and he was twenty-two.</p>
<p class="tx">We lived a normal life. David finished college and went on to graduate school. I went to cosmetology school at night and cared for our daughter during the day. We moved from Pittsburgh, Pennsylvania, to Rochester, New York, to San Diego, California, to Tenafly, New Jersey, adding another child, our son, along the way.</p>
<p class="tx">We lived a normal life as David went from assistant professor to full professor at Columbia University, and I earned my teaching certification from William Paterson University. I then taught first or third grade at Honiss School in Dumont, New Jersey, the town in which we raised our children.</p>
<p class="tx">We lived a normal life as we watched our children grow. We spent our time at gymnastic studios, soccer fields, cross-country courses, and softball fields. We went to parent-teacher conferences and back-to-school nights. We watched proudly as both children graduated college and took up their own lives.</p>
<p class="tx">We lived a normal life as empty nesters in New Jersey. We continued our date nights on Friday and Saturday, and <a id="page_xiv">sometimes, for extra measure, we had one mid-week too. We both enjoyed our jobs, and life was good.</a></p><a id="page_xiv">
<p class="tx">We lived a normal life until the dawn of January 13, 2005. Then we didn’t.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter04.vue?4af98af9